// keyFactories/ux/workflowKeyFactory.ts
import { WorkflowRunFilters } from "@features/ux/work-flow/types";
import { ActionType, EntityType, ModuleType } from "../../queryKeyFactory";

export const workflowKeyFactory = {
  // Basic workflow operations
  workflowTable: (
    filters?: any
  ): [ModuleType, EntityType, ActionType, any?] => [
    "ux",
    "uxWorkflow",
    "list",
    filters,
  ],

  // Single workflow
  workflowById: (
    workflowId?: number
  ): [ModuleType, EntityType, ActionType, number?] => [
    "ux",
    "uxWorkflow",
    "detail",
    workflowId,
  ],

  // Workflow by status
  workflowsDraft: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxWorkflow",
    "draft",
  ],

  workflowsActive: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxWorkflow",
    "active",
  ],

  workflowsAll: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxWorkflow",
    "all",
  ],

  // Workflow runs
  workflowRuns: (
    page?: number,
    limit?: number,
    search_data?: string,
    statusDisplay?: string,
    type?: string
  ) => [
    "ux",
    "workflow",
    "runs",
    page,
    limit,
    search_data,
    statusDisplay,
    type,
  ],

  workflowRunById: (runId: number) => [
    "ux",
    "uxWorkflow",
    "workflowRunById",
    runId,
  ],

  // Workflow performance and stats
  workflowPerformance: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxWorkflowPerformance",
    "list",
  ],

  workflowStats: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxWorkflowStats",
    "list",
  ],

  workflowStat: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxWorkflowStat",
    "list",
  ],

  // Workflow notifications
  workflowNotifications: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxWorkflowNotifications",
    "list",
  ],

  // Event types (used in workflow triggers)
  eventType: (): [ModuleType, EntityType, ActionType] => [
    "ux",
    "uxEventType",
    "list",
  ],

  // Message templates (used in workflow actions)
  messageTemplates: (
    channelType?: string
  ): [ModuleType, EntityType, ActionType, string?] => [
    "ux",
    "uxMessageTemplate",
    "list",
    channelType,
  ],

  // Template filters (if needed for workflow template selection)
  templatesFilter: (
    filters?: any
  ): [ModuleType, EntityType, ActionType, any?] => [
    "ux",
    "uxTemplate",
    "filtered",
    filters,
  ],
} as const;
